/**
 * HHD Sticky ATC Custom Element
 * Refactored from snippets/hhd-sticky-atc.liquid
 */

if (!customElements.get('hhd-sticky-atc')) {
  class HHDStickyATC extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.atcBtn = this.querySelector('.hhd-sticky-atc__atc-btn');
      this.selects = this.querySelectorAll('.hhd-sticky-atc__variant-select');
      this.sectionId = this.dataset.section;
      this.currentVariantId = this.dataset.variantId;
      this.header = document.querySelector('.header-section') || document.querySelector('header');
      this.header = document.querySelector('.header-section') || document.querySelector('header');
      this.mainSection = document.querySelector('.product--hhd') || document.querySelector('.product') || document.querySelector('[id^="MainProduct-"]');

      if (!this.mainSection) return;

      // Extract the product section ID from the observed mainSection
      this.productSectionId = this.mainSection.dataset.section || (this.mainSection.id ? this.mainSection.id.replace('MainProduct-', '') : this.sectionId);

      this.onVariantChangeBound = this.onVariantChange.bind(this);
      document.addEventListener('variant:changed', this.onVariantChangeBound);

      this.initScrollLogic();
      this.initSyncToMain();
      this.initATC();
    }

    disconnectedCallback() {
      if (this.onVariantChangeBound) {
        document.removeEventListener('variant:changed', this.onVariantChangeBound);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    initScrollLogic() {
      this.updateHeaderOffset();
      window.addEventListener('resize', () => this.updateHeaderOffset());

      const observerOptions = {
        threshold: 0,
        rootMargin: `-${this.header ? this.header.offsetHeight : 0}px 0px 0px 0px`
      };

      this.observer = new IntersectionObserver((entries) => this.toggleSticky(entries), observerOptions);
      this.observer.observe(this.mainSection);
    }

    updateHeaderOffset() {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      this.style.top = `${headerHeight}px`;
    }

    toggleSticky(entries) {
      entries.forEach(entry => {
        const isPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (isPast) {
          this.updateHeaderOffset();
          this.classList.add('hhd-sticky-atc--visible');
          this.setAttribute('aria-hidden', 'false');
        } else {
          this.classList.remove('hhd-sticky-atc--visible');
          this.setAttribute('aria-hidden', 'true');
        }
      });
    }

    onVariantChange(event) {
      if (!event.detail.variant) return;
      const variant = event.detail.variant;

      // Match section if event provides it. If we are global, we listen to the product section we identified at init.
      if (event.detail.sectionId && event.detail.sectionId !== this.productSectionId && event.detail.sectionId !== this.sectionId) return;

      const sectionIdForElements = event.detail.sectionId || this.productSectionId;
      this.currentVariantId = variant.id;

      // Update image
      if (variant.featured_media) {
        const img = this.querySelector(`img[id^="HHDStickyImage-"]`);
        if (img) img.src = variant.featured_media.preview_image.src + '&width=120';
      }

      // Update price
      const priceSource = document.getElementById(`price-${sectionIdForElements}`) || document.querySelector('.price');
      const priceElement = this.querySelector(`div[id^="HHDStickyPrice-"]`);
      if (priceSource && priceElement) {
        priceElement.innerHTML = priceSource.innerHTML;
      }

      // Update selects
      variant.options.forEach((val, idx) => {
        const select = this.querySelector(`.hhd-sticky-atc__variant-select[data-option-index="${idx}"]`);
        if (select) select.value = val;
      });

      // Update Button status
      if (this.atcBtn) {
        const btnText = this.atcBtn.querySelector('span');
        if (variant.available) {
          this.atcBtn.removeAttribute('disabled');
          if (btnText) btnText.textContent = window.FoxTheme?.variantStrings?.addToCart || 'Add to cart';
        } else {
          this.atcBtn.setAttribute('disabled', 'disabled');
          if (btnText) btnText.textContent = window.FoxTheme?.variantStrings?.soldOut || 'Sold out';
        }
      }
    }

    initSyncToMain() {
      this.selects.forEach(select => {
        select.addEventListener('change', () => {
          const index = parseInt(select.dataset.optionIndex);
          const value = select.value;
          
          // Try to find the variant-selects within the main product section we are observing
          const mainVariantSelects = this.mainSection.querySelector('variant-selects, variant-radios') || document.querySelector(`variant-selects[data-section="${this.productSectionId}"], variant-radios[data-section="${this.productSectionId}"]`);
          
          if (!mainVariantSelects) return;

          const fieldsets = mainVariantSelects.querySelectorAll('fieldset, select');
          const targetElement = fieldsets[index];

          if (targetElement) {
            if (targetElement.tagName === 'SELECT') {
              targetElement.value = value;
            } else {
              const radio = targetElement.querySelector(`input[value="${value}"]`);
              if (radio) radio.checked = true;
            }

            const originalScrollTo = window.scrollTo;
            window.scrollTo = function () { };

            targetElement.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));

            setTimeout(() => {
              window.scrollTo = originalScrollTo;
            }, 50);
          }
        });
      });
    }

    initATC() {
      if (!this.atcBtn) return;

      this.atcBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.currentVariantId) return;

        const btnTextElem = this.atcBtn.querySelector('span');
        const originalText = btnTextElem ? btnTextElem.textContent : '';
        const addingText = window.FoxTheme?.variantStrings?.addingToCart || 'Adding...';

        if (btnTextElem) btnTextElem.textContent = addingText;
        this.atcBtn.disabled = true;

        const body = JSON.stringify({
          items: [{ id: this.currentVariantId, quantity: 1 }],
          sections_url: window.location.pathname
        });

        fetch((window.FoxTheme?.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript'
          },
          body: body
        })
          .then(response => response.json())
          .then(parsedState => {
            if (parsedState.status && parsedState.status !== 200) {
              throw new Error(parsedState.description);
            }

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: parsedState }
            }));

            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true }
            }));
          })
          .catch(error => {
            console.error('Sticky ATC Error:', error);
            alert(error.message || 'Error adding to cart');
          })
          .finally(() => {
            this.atcBtn.removeAttribute('disabled');
            if (btnTextElem) btnTextElem.textContent = originalText;
          });
      });
    }
  }

  customElements.define('hhd-sticky-atc', HHDStickyATC);
}

